export const FETCH_TEACHER_CONSULTATIONS_JOURNAL = "FETCH_TEACHER_CONSULTATIONS_JOURNAL";
export const DELETE_TEACHER_CONSULTATION = "DELETE_TEACHER_CONSULTATION";
export const CALC_TEACHER_CONSULTATIONS_JOURNAL = "CALC_TEACHER_CONSULTATIONS_JOURNAL";


